module.exports = __webpack_public_path__ + "img/HiwaQader-YariFrishtaka.84babdf0.jpg";